const countries: Record<string, number> = {
  BRA: 11,
  ARG: 11,
  CHL: 11,
  COL: 10,
  ECU: 11,
  PER: 11,
  VEN: 11,
}

export const getLengthPhone = (countryCode: string) => countries[countryCode] || 11;
